export const SUGGESTION_ID_PREFIX = "id:"

export const parseSuggestionId = (value: string | null | undefined): string | null => {
  if (!value || !value.startsWith(SUGGESTION_ID_PREFIX)) return null
  return value.slice(SUGGESTION_ID_PREFIX.length)
}
